import { useCallback } from 'react'

import { useUser } from '../UserContext'

const usePermission = () => {
  const { user } = useUser()

  const hasPermission = useCallback(
    input => {
      if (!user?.permissions) return false

      const tags = Array.isArray(input) ? input : [input]

      const permissionTags = user.permissions.map(p => p.tag)

      if (permissionTags.includes('SUPERADMIN')) return true

      return tags.some(tag => permissionTags.includes(tag))
    },
    [user]
  )

  return hasPermission
}

export default usePermission
